const devDomains = ['localhost', '127.0.0.1']; //'dev.app.edwinpeople.co.uk',
export const isDevEnvironment = devDomains.includes(window.location.hostname); //import.meta.env.MODE === 'development' ||
